export default __webpack_public_path__ + "static/media/Blade of the Pillars.a157e0f7.jpg";